import { TenantList } from '@unistocks/features/admin/components/tenant-management/tenant-list';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function TenantManagementScreen() {
  return (
    <>
      <Head>
        <title>{t('AbpTenantManagement::Tenants')}</title>
      </Head>
      <TenantList />
    </>
  );
}
